import { apiFetch } from './client';

export interface HealthCheck {
  name: string;
  status: 'ok' | 'error';
  detail: string;
}

export interface HealthReport {
  status: 'ok' | 'error';
  service: string;
  api_version: string;
  version: string;
  request_id: string;
  checks: HealthCheck[];
}

export function fetchHealth(): Promise<HealthReport> {
  return apiFetch<HealthReport>('/health');
}
